import { Pipe, PipeTransform } from '@angular/core';
import { AssetFilter } from 'src/app/support/supportlog/filters/asset-filter/asset-filter.component';

@Pipe({
    name: 'assetPipe',
    pure: false
})
export class AssetPipes implements PipeTransform {

    constructor() {};

    transform(assets: any[], filter: AssetFilter): any {
        return assets.filter(asset => {
            // check vendor's name
            const containVendor = asset.fullName.toLowerCase().indexOf(filter.search.toLowerCase()) !== -1;
            // check serial number
            const containSearch = asset.vendor.toLowerCase().indexOf(filter.vendor.toLowerCase()) !== -1;

            return containSearch && containVendor;
        });
    }
}
